var Vendd = (function (Vendd) {
    'use strict';

    Vendd.MessageBus.subscribe(Vendd.ProductList.Messages.GetModel, Vendd.ProductList, function (envelope) {
        var data = envelope.message.data;
        if (data.serviceConfiguration == undefined || data.serviceConfiguration == '') return;

        var configuration = JSON.parse(data.serviceConfiguration);
        var item = configuration.ItemId != undefined && configuration.ItemId > 0 && configuration.ItemPath != undefined ?
            { Id: configuration.ItemId, Path: configuration.ItemPath } :
            LhApp.Context.Item;
        $(data.list).attr('data-current-page', 1);
        var requestData =
        {
            "templateCode": data.type,
            "configCode": "",
            "itemId": LhApp.Context.Item.Id,
            "itemPath": LhApp.Context.Item.Path,
            "pageNumber": 1,
            "pageSize": configuration.PageSize,
            "sortKey": configuration.SortKey,
            "fullPath": item.FullPath,
            "excludeItemIds": configuration.ExcludeItemIds,
            "includeFilters": data.includeFilters,
            "defaultUriFilter": data.defaultUriFilter
        };
        var options = {
            url: 'CachedServices/api/Product/GetAjaxProductList' + data.uri,
            servicenamespace: '',
            method: 'GET',
            data: requestData,
            onSuccess: onSuccess,
            onFailure: onFailure
        };
         
        function onSuccess(response) {
            Vendd.MessageBus.publishAsync(Vendd.ProductList, new Vendd.ProductList.Messages.GetModelSuccess(response, data.list));
        };

        function onFailure(response) {
            Vendd.MessageBus.publishAsync(Vendd.ProductList, new Vendd.ProductList.Messages.GetModelFailed(response, data.list));
        };

        Vendd.Service.call(options);
    });

    return Vendd;

})(Vendd || {});